import axios from "axios";
import router from "../router";
const ls = require("local-storage");
const _axios = axios.create({
  baseURL: "http://localhost:3001/api",
  // baseURL: 'http://192.168.20.2:3001/api' //************************** LOCAL - LUENA */
  // baseURL: 'http://102.130.192.52:3001/api' //************************** LOCAL ISPA- ATLANTIDA */
  // baseURL: 'http://192.168.1.254:3001/api' // **************** Esca
  // baseURL: 'http://192.168.0.9:3001/api'
  // baseURL: 'http://169.254.158.200:3001/api' // Cital
  // baseURL: 'https://restrito.isppluena.com/api' //* LUENA ONLINE
  // baseURL: 'https://api.bendizer.net/api' //Pedagógico  ********************* BENDIZER
  // baseURL: 'https://restrito.ilhaverdade.gereonline.com/api' //Pedagógico  ********************* ILHA DA VERDADE
  // baseURL: 'http://192.168.1.191:3001/api' //Pedagógico  ********************* local LUENA
  // baseURL: 'https://api.ispatlantida.com/api' // Atlantida - Ped
  // baseURL: 'https://api.ispamazozo.com/api' // Mazozo - Ped
  // baseURL: 'http://192.168.1.9:3001/api' // Teste - Local
  // baseURL-Finanças : 'http://192.168.1.9:3000/fin/api'
});
// Add a request interceptor*
_axios.interceptors.request.use(function (config) {
  try {
    const token = "IntegracaoFinanceiroPed-Bendizer";
    const role = ls.get("role");
    const idInstituicao = 7;
    const anolectivo = ls.get("anolectivo");
    const idPessoa = ls.get("idPessoa");
    const nomeUsuario = ls.get("nomeUsuario");
    config.headers.Authorization = token
      ? `Bearer ${token} ${role} ${idInstituicao} ${anolectivo} ${idPessoa} ${nomeUsuario}`
      : "";
    return config;
  } catch (error) {
    console.log("_axios.interceptors.request.use error: " + error);
    return Promise.reject(error);
  }
});

_axios.interceptors.response.use(
  (response) => {
    // Do something with response data

    return response;
  },
  (error) => {
    // Do something with response error

    // You can even test for a response code
    // and try a new request before rejecting the promise
    try {
      if (error.response.status === 403 || error.response.status === 401) {
        ls.set("fatal", "Acesso negado");
        router.push("/");
      }
    } catch (err) {
      ls.set("fatal", "" + err + " ->  " + error);
      // router.push('/')
    }

    return Promise.reject(error);
  }
);

/** */
export default _axios;
